import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Lock, LogIn } from "lucide-react";
import { toast } from "react-toastify";
import { login } from "../../../services/authService";
import "./Login.css";

const SITE_NAME = "JMJK Properties";

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  function validate() {
    const map = {};
    if (!form.email.trim()) map.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      map.email = "Enter a valid email";
    if (!form.password.trim()) map.password = "Password is required";
    setErrors(map);
    return Object.keys(map).length === 0;
  }

  async function onSubmit(e) {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);
    setErrors({});

    try {
      const data = await login(form.email.trim(), form.password);

      // Expected: { message, user: { id, name, email, role }, token }
      const userPayload = {
        ...data.user,
        token: data.token,
      };

      localStorage.setItem("user", JSON.stringify(userPayload));
      localStorage.setItem("token", data.token);
      localStorage.setItem("isAuthenticated", "true");

      toast.success(data.message || "Login successful");
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      const msg = err.message || "Login failed. Please try again.";
      toast.error(msg);
      setErrors({ password: msg });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="lg-wrap">
      <div className="lg-card">
        <div className="lg-eyebrow">Admin</div>
        <h1 className="lg-title">{SITE_NAME} Admin</h1>
        <p className="lg-sub">
          Sign in to manage properties, cities and developers.
        </p>

        <form onSubmit={onSubmit} className="lg-form" noValidate>
          <div>
            <label className="lg-label">Email</label>
            <div className="lg-field">
              <Mail className="lg-field-ico" />
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="lg-input"
                placeholder="admin@JMJK.com"
                autoComplete="username"
                disabled={submitting}
              />
            </div>
            {errors.email && <p className="lg-err">{errors.email}</p>}
          </div>

          <div>
            <label className="lg-label">Password</label>
            <div className="lg-field">
              <Lock className="lg-field-ico" />
              <input
                type="password"
                value={form.password}
                onChange={(e) =>
                  setForm({ ...form, password: e.target.value })
                }
                className="lg-input"
                placeholder="••••••••"
                autoComplete="current-password"
                disabled={submitting}
              />
            </div>
            {errors.password && <p className="lg-err">{errors.password}</p>}
          </div>

          <button type="submit" disabled={submitting} className="lg-btn">
            <LogIn className="h-4 w-4" />
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}